import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/pro-regular-svg-icons/faLock";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

interface Props {
  element: DocumentElementType;
}

/**
 * A job board or job list as a reader outside Eaco sees it — which is to say,
 * not at all.
 *
 * These blocks are a live window onto the client's jobs: who is assigned, what
 * is overdue, what is in progress. None of that belongs on a public link or in
 * a PDF that leaves the building, and unlike an action item there is no
 * name-only version worth showing. So the block says a view sits here and
 * stops, rather than silently vanishing and leaving a hole in the document.
 */
const PageJobCollectionView: React.FC<Props> = ({ element }) => {
  const data = (element.data ?? {}) as { title?: string | null };
  const label = element.typeId === "page-job-list" ? "Job list" : "Job board";

  return (
    <div className="flex items-center gap-[10px] rounded-[12px] border border-dashed border-[#e2e0db] bg-[#faf9f7] px-[14px] py-[13px]">
      <FontAwesomeIcon
        icon={faLock}
        className="text-[#b4b0a8]"
        style={{ fontSize: 13 }}
      />
      <span className="min-w-0">
        <span className="block text-[13px] font-bold text-[#6a6660]">
          {data.title || label}
        </span>
        <span className="block text-[11.5px] text-[#a5a199]">
          Live job data — only visible inside Eaco.
        </span>
      </span>
    </div>
  );
};

export default PageJobCollectionView;
